import { fromJS } from 'immutable';
import * as actionTypes from '../actions/umoCarouselActionTypes';

const initialState = fromJS({
  currentIndex: 0,
  maxIndex: 0,
});

const umoCarousel = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UMO_CAROUSEL_NEXT: {
      const maxIndex = state.get('maxIndex');
      const currentIndex = state.get('currentIndex');
      const nextIndex = currentIndex < maxIndex ? currentIndex + 1 : 0;
      return state.set('currentIndex', nextIndex);
    }
    case actionTypes.UMO_CAROUSEL_PREV: {
      const currentIndex = state.get('currentIndex');
      const prevIndex =
        currentIndex > 0 ? currentIndex - 1 : state.get('maxIndex');
      return state.set('currentIndex', prevIndex);
    }
    case actionTypes.UMO_CAROUSEL_MAX_INDEX:
      return state.set('maxIndex', action.maxIndex);
    case actionTypes.UMO_CAROUSEL_SET_INDEX:
      return state.set('currentIndex', action.index);
    default:
      return state;
  }
};

export default umoCarousel;
